module.exports = __webpack_public_path__ + "img/2.e79da6b7.png";